import { useQueryClient } from "@tanstack/react-query";

/**
 * @description queryClient 초기화 Hook
 */
const useQueryInvaildate = () => {
  const queryClient = useQueryClient();

  /**
   * @param key query Client 캐싱 키
   * @description 전달받은 키에 해당하는 쿼리를 무효화
   *
   * 콜백으로 메모이제이션 해둠
   */
  const invalidate = async (key: string[]) => {
    await queryClient.invalidateQueries({
      queryKey: key,
    });
  };

  return { invalidate };
};

export default useQueryInvaildate;
